var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupe1681(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 106,
    viewBox: "0 0 97 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1681",
    "data-name": "Groupe 1681",
    transform: "translate(-13228 -1263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1287",
    "data-name": "Rectangle 1287",
    d: "M0,0H97a0,0,0,0,1,0,0V57.5A48.5,48.5,0,0,1,48.5,106h0A48.5,48.5,0,0,1,0,57.5V0A0,0,0,0,1,0,0Z",
    transform: "translate(13228 1263)",
    fill: "#f3f8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chart",
    transform: "translate(13256 1298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H36.095",
    transform: "translate(3.426 33.686)",
    fill: "none",
    stroke: "#3d79f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,3.062V30.624H7.708V3.062A2.75,2.75,0,0,0,4.625,0H3.083A2.75,2.75,0,0,0,0,3.062Z",
    transform: "translate(17.557 3.063)",
    fill: "none",
    stroke: "#3d79f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,3.062V21.436H6.851V3.062C6.851,1.378,6.166,0,4.111,0H2.741C.685,0,0,1.378,0,3.062Z",
    transform: "translate(5.138 12.251)",
    fill: "none",
    stroke: "#3d79f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,3.062V13.781H6.851V3.062C6.851,1.378,6.166,0,4.111,0H2.741C.685,0,0,1.378,0,3.062Z",
    transform: "translate(30.833 19.905)",
    fill: "none",
    stroke: "#3d79f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H41.108V36.748H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe1681);
export default __webpack_public_path__ + "static/media/Groupe-1681.3f696934b147831ece54e7fc2459a9cf.svg";
export { ForwardRef as ReactComponent };